
const intial={
	a:require("./data"),
	message:"",
	option:null
}
let reducer=function(state=intial,action){
	switch(action.type)
	{
		case "insert":
			return {
				...state,
				a:[...state.a,{id:state.a.length+1,name:action.payload,status:false}]
			}
		case "delete":
			return {
				...state,
				a:state.a.filter(x=>x.id!==action.payload)
			}
		case "delete1":
			return {
				...state,
				a:state.a.filter(x=>x.status!==true)
			}
		case "delete2":
			return {
				...state,
				a:state.a.filter(x=>x.status!==false)
			}
		case "delete3":
			return {
				...state,
				a:[]
			}
			
		case "update":
			return {
				...state,
				a:state.a.map(x=>x.id!==action.payload.id?(x):(action.payload))
			}
		case "option":
			return {
				...state,
				option:action.payload
			}
			
		default :
		return state
	}	

}

export default reducer;